/**
 * Minimal icon color tokens, extracted from `@faire/slate/foundation/color`
 * so the icon set stays a dependency-light leaf. Each value is a CSS custom
 * property (defined by Slate's theme CSS) with a static hex fallback, so icons
 * render correctly even in apps that do not load the full Slate theme.
 *
 * Keep these in sync with `Core.icon` in
 * `packages/core/slate/src/foundation/color/semantic.ts`.
 */
export const iconColor = {
  primary: "var(--slate-color-icon-primary, #333333)",
  subdued: "var(--slate-color-icon-subdued, #6c6a6a)",
  primaryInverse: "var(--slate-color-icon-primary-inverse, #ffffff)",
} as const;
